import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import MissionSection from "./components/MissionSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import ServicesSection from "./components/ServicesSection";
import CoreValuesSection from "./components/CoreValuesSection";
import ContactPage from "./components/ContactPage";
import ApplyPage from "./components/ApplyPage";
import AboutMePage from "./components/AboutMePage";
import ServicePage from "./components/ServicePage";
import ServicesIndexPage from "./components/ServicesIndexPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Home Page Component
function HomePage() {
  return (
    <>
      <Helmet>
        <title>A Gentle Touch HomeCare | Non Medical Home Care Services in Columbus, Ohio</title>
        <meta name="description" content="A Gentle Touch HomeCare provides compassionate non medical home care, companion care, and personal care services for seniors in Columbus, Ohio. Professional in home caregivers helping your loved ones live safely at home. Call 614-928-4169." />
        <link rel="canonical" href="https://agentletouchhomecare.com/" />
      </Helmet>
      <HeroSection />
      <MissionSection />
      <WhyChooseUsSection />
      <ServicesSection />
      <CoreValuesSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-me" element={<AboutMePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/services" element={<ServicesIndexPage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
